module.exports = __webpack_public_path__ + "img/spoc_bg.7c8f9334.jpg";